import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../apiFetch";

export default function SettingsPage() {
 const navigate = useNavigate();

  const [servers, setServers] = useState([]);
  const [configs, setConfigs] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [testStatus, setTestStatus] = useState(null); 
// null | "success" | "error" | "loading"

  const [selectedServer, setSelectedServer] = useState("");
  const [selectedConfig, setSelectedConfig] = useState("");

  // ✅ Load dropdown data
  useEffect(() => {
    fetchServers();
    fetchConfigs();
    fetchMappings();
  }, []);

  const fetchServers = async () => {
    //const res = await fetch(process.env.REACT_APP_BACKEND_URL + "es/servers");
    //const data = await res.json();

   setServers( [{ "id": 1, "name": "Prod Cluster" },
  { "id": 2, "name": "UAT Cluster" }]);
  };

  const fetchConfigs = async () => {
   // const res = await fetch(process.env.REACT_APP_BACKEND_URL + "file-mapping-config");
   // const data = await res.json();
   let data = [{
  "serverId": 1,
  "configId": 5
}]
    setConfigs( data || []);
  };

  const fetchMappings = async () => {
    const res = await apiFetch("es/config-mapping");
    const data = await res.json();
    setMappings(data || []);
  };

  // ✅ Save Mapping
  const handleSave = async () => {
    if (!selectedServer || !selectedConfig) {
      alert("Please select both fields");
      return;
    }

    await apiFetch("es/config-mapping", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        serverId: selectedServer,
        configId: selectedConfig,
      }),
    });

    fetchMappings(); // refresh table
  };

  /**================================
   * 
   ===================================*/

    const handleTestConnection = async () => {
    if (!selectedServer) {
        alert("Please select server");
        return;
    }

    try {
        setTestStatus("loading");

        const res = await apiFetch(
         "es/test-connection",
        {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify({
            serverId: selectedServer,
            }),
        }
        );

        const data = await res.json();

        if (data.success) {
        setTestStatus("success");
        } else {
        setTestStatus("error");
        }

    } catch (err) {
        console.error(err);
        setTestStatus("error");
    }
    };

  return (
    <div className="bg-gray-50 min-h-screen p-6 font-display text-slate-900 min-h-screen flex flex-col">
      
      {/* MAIN */}
      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">

      {/* HEADER */}
      <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm mb-6 flex items-center justify-between">
          <div>
            <div className="text-xs font-black tracking-[0.3em] text-slate-400 uppercase">
              Reconciliation
            </div>

            <h1 className="mt-2 text-2xl font-black text-slate-900">
               Server Settings
            </h1>

            <p className="mt-2 text-slate-500">
              Settings to view elasticsearch data.
            </p>
          </div>
          <div>
              <button
                onClick={() => navigate("/")}
                className="text-blue-600 font-medium"
              >
                ← Back to Dashboard
              </button>
          </div>
      </div>

      {/* FORM CARD */}
      <div className="bg-white shadow rounded-lg p-6 mb-6">

        <div className="grid grid-cols-2 gap-4">

          {/* Elasticsearch Server */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Elasticsearch Server
            </label>
            <select
              value={selectedServer}
              onChange={(e) => setSelectedServer(e.target.value)}
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Select Server</option>
              {servers.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          {/* Config */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Config
            </label>
            <select
              value={selectedConfig}
              onChange={(e) => setSelectedConfig(e.target.value)}
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Select Config</option>
              {configs.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.config_name}
                </option>
              ))}
            </select>
          </div>

        </div>

        {/* SAVE BUTTON */}
        <div className="mt-4">
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            Save Mapping
          </button>
        </div>
        <div className="flex items-center gap-3 mt-4">

        {/* TEST BUTTON */}
        <button
            onClick={handleTestConnection}
            className="px-4 py-2 bg-gray-700 text-white rounded"
        >
            Test Connection
        </button>

        {/* STATUS INDICATOR */}
        {testStatus === "loading" && (
            <span className="text-gray-500">Testing...</span>
        )}

        {testStatus === "success" && (
            <span className="text-green-600 font-medium">
            ● Connected
            </span>
        )}

        {testStatus === "error" && (
            <span className="text-red-600 font-medium">
            ● Failed
            </span>
        )}

        </div>

      </div>

      {/* MAPPING TABLE */}
      <div className="bg-white shadow rounded-lg p-4">

        <h2 className="text-lg font-semibold mb-4">
          Existing Mappings
        </h2>

        <table className="min-w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-3 py-2">Server</th>
              <th className="border px-3 py-2">Config</th>
            </tr>
          </thead>

          {/* <tbody>
            {mappings?.map((m, i) => (
              <tr key={i}>
                <td className="border px-3 py-2">{m.serverName}</td>
                <td className="border px-3 py-2">{m.configName}</td>
              </tr>
            ))}
          </tbody> */}
        </table>

      </div>
     </main>
    </div>
  );
}